// extracted by mini-css-extract-plugin
export default {"item":"AccountMenu_item__5z-od","triangle":"AccountMenu_triangle__malqu"};